import { useQuery } from '@tanstack/react-query';
import { fetchDiffsAnalytics } from '@/utils/diffsAnalyticsAPI';
import type { DiffsAnalyticsRequest, DiffsAnalyticsResponse } from '@/components/reports/graphs/types';

export function useDiffsAnalytics(request: DiffsAnalyticsRequest | null) {
  const result = useQuery<DiffsAnalyticsResponse, Error>({
    queryKey: ['diffsAnalytics', request],
    queryFn: () => {
      if (!request) {
        throw new Error('No request provided');
      }
      return fetchDiffsAnalytics(request);
    },
    enabled: !!request && !!request.periods && request.periods.length >= 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 2,
  });

  return result;
}
